// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/MyLists/MyListsHeader";
import { xScreen } from "@keller/XDL/Utilities/";
import { css } from "styled-components";

headerStyles.container = {
    gap: 15,
    css: css`
        padding-bottom: 20px;
        position: relative;
    `,
};

// Title
headerStyles.leftTopGridItem = {
    width: [10, 12, 12, 12, 12],
    css: css`
        order: 1;
    `,
};

// Search field
headerStyles.leftBottomGridItem = {
    width: [12, 8, 8, 8, 8],
    css: css`
        order: 2;
        ${xScreen("lte", "xs")} {
            order: 4;
        }
    `,
};

// Sort field
headerStyles.rightBottomGridItem = {
    width: [12, 3, 2, 2, 2],
    css: css`
        order: 3;
        ${xScreen("lte", "xs")} {
            order: 3;
        }
    `,
};

// OverflowMenu
headerStyles.rightTopGridItem = {
    width: [2, 1, 2, 2, 2],
    css: css`
        order: 4;
        ${xScreen("lte", "xs")} {
            order: 2;
        }
    `,
};
